export const USER_SPOTIFY_AUTH_FAIL = 'USER_SPOTIFY_AUTH_FAIL';
export const USER_SPOTIFY_AUTH_REQUEST = 'USER_SPOTIFY_AUTH_REQUEST';
export const USER_SPOTIFY_AUTH_SUCCESS = 'USER_SPOTIFY_AUTH_SUCCESS';
export const USER_SPOTIFY_AUTH_LOGOUT = 'USER_SPOTIFY_AUTH_LOGOUT';
